export const userInitialState = {
  user: null,
  userRoles: [],
  token: null,
  isAuthenticated: false,
};
